/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sidesheet-wrapper[_ngcontent-%COMP%]{overflow-y:auto;height:100%;width:100%}[_nghost-%COMP%]{min-width:320px;background:#fff;position:absolute;top:0;right:0;height:100%;overflow:hidden}@media (max-width:575.98px){[_nghost-%COMP%]{width:100vw!important}}"];
export { styles as styles };
